module.exports = __webpack_public_path__ + "img/red_top.9297be3e.png";